import React from 'react';
import NavbarLP from './NavbarLP';

function HeaderLP() {
  return (
    <div className='landing-header'>
        <NavbarLP/>
      
    </div>
  )
}

export default HeaderLP
